import PropTypes from "prop-types";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";

// import FirstPage from "@mui/icons-material/FirstPage";
// import LastPage from "@mui/icons-material/LastPage";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";

const Pagination = ({ disableNextPage = true, disablePreviousPage = true, page = 0, pageSize = 0, totalCount = 0, pageSizeOptions = [5, 10, 20, 50], handlePageSizeChange = () => {}, handleNextPageClick = () => {}, handlePreviousPageClick = () => {} }) => {
    const start = totalCount <= page * pageSize ? totalCount : page * pageSize + 1;
    const end = Math.min((page + 1) * pageSize, totalCount); // Ensure `end` doesn't exceed totalCount

    const totalPage = Math.ceil(totalCount / pageSize);
    const currentPage = page + 1 > totalPage ? totalPage : page + 1;
    return (
        <div
            style={{
                borderLeft: "1px solid #babfc7",
                borderRight: "1px solid #babfc7",
                borderBottom: "1px solid #babfc7",
                padding: "10px 10px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    justifyContent: "end",
                }}
            >
                <div>
                    <InputLabel
                        style={{
                            fontSize: "12px",
                            display: "inline",
                        }}
                        id="demo-simple-select-label"
                    >
                        Page Size:
                    </InputLabel>
                    <Select
                        value={pageSize}
                        onChange={(event) => handlePageSizeChange(event, event.target.value)}
                        size="small"
                        sx={{
                            minWidth: 50,
                            fontSize: "12px",
                            marginLeft: "5px",
                            height: "25px",
                            padding: "5px 5px 5px 0px",
                        }}
                    >
                        {pageSizeOptions.map((option) => (
                            <MenuItem
                                className="b"
                                key={option}
                                value={option}
                                dense={true}
                                sx={{
                                    fontSize: "12px",
                                    padding: "0px auto",
                                    margin: "0px auto",
                                }}
                            >
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </div>
                <div>
                    <InputLabel
                        style={{
                            fontSize: "12px",
                            display: "inline",
                        }}
                        id="demo-simple-select-label"
                    >
                        {" "}
                        {start} to {end} of {totalCount}
                    </InputLabel>
                </div>
                <div>
                    {/* <IconButton
                        size="small"
                    >
                        <FirstPage fontSize="small" />
                    </IconButton> */}
                    <IconButton
                        onClick={(event) => handlePreviousPageClick(event)}
                        disabled={disablePreviousPage}
                        size="small"
                    >
                        <KeyboardArrowLeft fontSize="small" />
                    </IconButton>
                    <InputLabel
                        style={{
                            fontSize: "12px",
                            display: "inline",
                        }}
                        id="demo-simple-select-label"
                    >
                        Page {currentPage} of {totalPage}
                    </InputLabel>
                    <IconButton
                        onClick={(event) => handleNextPageClick(event)}
                        disabled={disableNextPage}
                        size="small"
                    >
                        <KeyboardArrowRight fontSize="small" />
                    </IconButton>
                    {/* <IconButton
                        size="small"
                    >
                        <LastPage fontSize="small" />
                    </IconButton> */}
                </div>
            </div>
        </div>
    );
};

Pagination.propTypes = {
    page: PropTypes.number,
    pageSize: PropTypes.number,
    totalCount: PropTypes.number,
    pageSizeOptions: PropTypes.array,
    handlePageSizeChange: PropTypes.func,
    handleNextPageClick: PropTypes.func,
    handlePreviousPageClick: PropTypes.func,
    disableNextPage: PropTypes.bool,
    disablePreviousPage: PropTypes.bool,
};

export default Pagination;
